/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Router} from "@angular/router";
import {AuthenticationService} from "./authentication.service";
import { HttpHeaders } from "@angular/common/http";

export abstract class BaseService {
  
  constructor(
    private mRouter: Router,
    private mAuthenticationService: AuthenticationService
  ) { }
  
  handleError(error: any): Promise<any> {
    const response: Response = error;
    
    //401 = Unauthorized.  If an Unauthorized response is returned... The Token must be invalid.  Redirect the User to the login page
    if (response.status == 401) {
      console.error("BaseService.handleError() - Unauthorized HTTP Status detected... Token must of expired!  Redirecting to login...");
      this.mAuthenticationService.logout();
      this.mRouter.navigate(['/login'], {queryParams: {returnUrl: this.mRouter.url}});
      return Promise.reject(null);
    }
    
    //Any other type of error return to the caller for appropriate handling
    return Promise.reject(error);
  }
  
}
